import { jwtDecode } from 'jwt-decode';
export default {
  getuserrole: function () {
    var token = sessionStorage.getItem('authToken');
    if (!token) return null;
    const decodedToken = jwtDecode(token);
    const roles = decodedToken.roles;
    return roles[0];
  },
  canaccess: function (role) {
    var token = sessionStorage.getItem('authToken');
    if (!token) return null;
    const decodedToken = jwtDecode(token);
    const roles = decodedToken.roles;
    return role == roles[0] || roles[0] == "admin";
  },
  getuser: function () {
    var token = sessionStorage.getItem('authToken');
    const decodedToken = jwtDecode(token);
    return { username: decodedToken.username, userId: decodedToken.userId };
  },
  gettoken: () => sessionStorage.getItem('authToken'),
  formatnumber: (number) => {
    if (number === null || number === undefined) return '0.00';
    return parseFloat(number).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  },
  getCustomers: async (SetCustomers, setError) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getCustomers`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('authToken')}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok) {

        SetCustomers(data.Customers);
      } else {

        setError(data.message || 'Failed to fetch customer list');
      }
    } catch (err) {
      setError('An error occurred while fetching the customer list.');
    }
  },
  bank: [
    { value: 'SCB', text: 'ธนาคารไทยพาณิชย์', color: "#4e2e7f" },
    { value: 'KBANK', text: 'ธนาคารกสิกรไทย', color: "#138f2d" },
    { value: 'BBL', text: 'ธนาคารกรุงเทพ', color: "#1e4598" },
    { value: 'KTB', text: 'ธนาคารกรุงไทย', color: "#1ba5e1" },
    { value: 'TTB', text: 'ธนาคารทหารไทยธนชาต', color: "#ecf0f1" },
    { value: 'BAY', text: 'ธนาคารกรุงศรีอยุธยา', color: "#fec43b" },
    { value: 'GSB', text: 'ธนาคารออมสิน', color: "#eb198d" },
    { value: 'UOB', text: 'ธนาคารยูโอบี', color: "#0b3979" },
    { value: 'CIMB', text: 'ธนาคารซีไอเอ็มบีไทย', color: "#7e2f36" },
  ],

  calculateline: function (jobitem, itemperpage) {
    var totallineperitem = jobitem.map(item => {
      var allline = 1;
      var line = item.item.split("\n");
      allline = line.length;
      for (var i of line) {
        if (i.length > 50) {
          allline +=  (~~(i.length / 50)) +1;
        }
      }
      return allline;

    });
    var lineperpage = totallineperitem.slice(0, itemperpage);
    var sumline = lineperpage.reduce((a, b) => a + b, 0)
    itemperpage -= ~~(sumline / itemperpage)  +1;
    return itemperpage;

  },
  BAHTTEXT: function (num, suffix) {

    if (typeof suffix === 'undefined') {
      suffix = 'บาทถ้วน';
    }

    num = num || 0;
    num = num.toString().replace(/[, ]/g, ''); // remove commas, spaces

    if (isNaN(num) || (Math.round(parseFloat(num) * 100) / 100) === 0) {
      return 'ศูนย์บาทถ้วน';
    } else {

      var t = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'],
        n = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'],
        len,
        digit,
        text = '',
        parts,
        i;

      if (num.indexOf('.') > -1) { // have decimal

        /* 
         * precision-hack
         * more accurate than parseFloat the whole number 
         */

        parts = num.toString().split('.');

        num = parts[0];
        parts[1] = parseFloat('0.' + parts[1]);
        parts[1] = (Math.round(parts[1] * 100) / 100).toString(); // more accurate than toFixed(2)
        parts = parts[1].split('.');

        if (parts.length > 1 && parts[1].length === 1) {
          parts[1] = parts[1].toString() + '0';
        }

        num = parseInt(num, 10) + parseInt(parts[0], 10);


        /* 
         * end - precision-hack
         */
        text = num ? this.BAHTTEXT(num) : '';

        if (parseInt(parts[1], 10) > 0) {
          text = text.replace('ถ้วน', '') + this.BAHTTEXT(parts[1], 'สตางค์');
        }

        return text;

      } else {

        if (num.length > 7) { // more than (or equal to) 10 millions

          var overflow = num.substring(0, num.length - 6);
          var remains = num.slice(-6);
          return this.BAHTTEXT(overflow).replace('บาทถ้วน', 'ล้าน') + this.BAHTTEXT(remains).replace('ศูนย์', '');

        } else {

          len = num.length;
          for (i = 0; i < len; i = i + 1) {
            digit = parseInt(num.charAt(i), 10);
            if (digit > 0) {
              if (len > 2 && i === len - 1 && digit === 1 && suffix !== 'สตางค์') {
                text += 'เอ็ด' + t[len - 1 - i];
              } else {
                text += n[digit] + t[len - 1 - i];
              }
            }
          }

          // grammar correction
          text = text.replace('หนึ่งสิบ', 'สิบ');
          text = text.replace('สองสิบ', 'ยี่สิบ');
          text = text.replace('สิบหนึ่ง', 'สิบเอ็ด');

          return text + suffix;
        }

      }

    }
  },
}


